import { TextField } from "@mui/material";
import React, { useState } from "react";
import DropdownIcon from "../../../components/DropdownIcon/DropdownIcon";
import { useCustomHook } from "../../../../GlobalFunctions/globalFunctions";

const ContactTool = ({ modalData, updateModalState, formik }) => {
  const [openDropdown, setOpenDropdown] = useState(false);

  const { contactToolList } = useCustomHook();

  const inputValue =
    contactToolList?.find((item) => item?.key === modalData?.contactTool)
      ?.value || "";

  const addData = (item) => {
    console.log(item, "item");
    updateModalState("contactTool", item.key);
    setOpenDropdown(false);
  };

  return (
    <>
      <div className="class-input">
        <div className="dropdown-input">
          <div className="input-box">
            <TextField
              sx={{
                "& input": {
                  fontSize: "12px",
                  marginRight: "32px",
                },
                marginTop: "24px",
                // marginBottom: "24px",
              }}
              InputLabelProps={{
                style: { fontSize: "12px", color: "#3F3F3F" },
              }}
              fullWidth
              label="Əlaqə vasitəsi"
              autoComplete="off"
              disabled
              value={inputValue}
              onBlur={() => formik.setFieldTouched("contactTool", true)}
            />
            <DropdownIcon
              setOpenDropdown={setOpenDropdown}
              openDropdown={openDropdown}
            />
          </div>

          <ul
            className={`dropdown-body where-coming ${
              openDropdown ? "active" : ""
            }`}
          >
            {contactToolList?.map((item) => (
              <li key={item.key} onClick={() => addData(item)}>
                <h4>{item.value}</h4>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {formik.errors.teacher && formik.touched.teacher && (
        <small className="validation-err-message">
          {formik.errors.teacher}
        </small>
      )}
    </>
  );
};

export default ContactTool;
